import logo from './logo.svg';
import {Route,Switch,BrowserRouter} from 'react-router-dom'
import HomePage from './Pages/Home'
import About from './Pages/About'
import Contact from './Pages/Contact'
import Portfolio from './Pages/Portfolio'
import styled from "@emotion/styled";

function App() {
  const DIV = styled.div`
    background-color:black;
  `;
  return (
    <DIV className="App">
      <BrowserRouter>
      <Switch>
        <Route path="/" exact component={HomePage} />
        <Route path="/aboutus" exact component={About} />
        <Route path="/contact" exact component={Contact} />
        {/* <Route path="/portfolio" exact component={Portfolio} /> */}
        {/* <Route component={PageNotFound} /> */}
      </Switch>
      </BrowserRouter>
    </DIV>
  );
}

export default App;
